module.exports = __webpack_public_path__ + "static/img/crm.8a558455.png";